module.exports = __webpack_public_path__ + "21eb7d2575204cc25fb1f825cb6fd7e8.svg";